import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { App_FormBloc, App_FormCreatorJson, App_FormSketchFormDynamique, App_FormStep } from 'src/app/utils/interfaces';
import { Type_App_Validator, Type_FieldOrLabel } from 'src/app/utils/types';

@Component({
  selector: 'app-c-form-dynamique',
  templateUrl: './c-form-dynamique.component.html',
  styleUrls: ['./c-form-dynamique.component.scss'],
})
export class CFormDynamiqueComponent implements OnInit {
  @Input({ required: true }) modeShow!: boolean;

  @Input({ required: true }) formGroup!: FormGroup;
  @Input({ required: true }) formSketchFormDynamique!: App_FormSketchFormDynamique;

  @Input({ required: true }) forms!: FormGroup;
  @Input({ required: true }) blocName!: string;

  @Input() etatId?: number;
  @Input({ required: true }) display!: App_FormCreatorJson; // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) context!: 'preparation' | 'edition';

  @Input({ required: true }) observeSourcesArr!: { formControl: FormControl; validator: Type_App_Validator; }[]; // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) step!: App_FormStep // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) bloc!: App_FormBloc // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) displayType: 'markerRow-fieldColum' | 'markerColumn-fieldRow' = 'markerRow-fieldColum'

  @Input({ required: true }) index!: number;

  @Input({ required: true }) sourceMarqueurs: any;

  @Input({ required: true }) canEditDescription!: boolean;

  @Output() modifiedDescription = new EventEmitter<{
  label: string,
    description: string,
    index: number
  }>();

  champs: Type_FieldOrLabel[] = [];

  constructor() { }

  ngOnInit() {
    const champs = this.formSketchFormDynamique?.champs;
    if (Array.isArray(champs)) {
      this.champs = champs
    }
  }

  editDescription($event: any, legendElement: { label: string, description: string, index: number }, index: number) {
    const value = $event.detail.value;
    if (typeof value === 'string' && value.length > 0) {
      const description = value.trim();
      this.modifiedDescription.emit({
        label: legendElement.label,
        description,
        index
      });
    }
  }

}
